import { useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import { titleMarginBottom } from '../constants/layout'
import { useAppSelector } from '../redux/hooks'
import useUserComplianceActions from '../hooks/useUserComplianceActions'
import FullScreenLoadingIndicator from '../components/FullScreenLoadingIndicator'
import UserComplianceList from '../components/Aml/User/UserComplianceList'
import Card from "../components/Card";

const UserCompliance = () => {
  const styles = useStyles()
  const { getUserCompliances } = useUserComplianceActions()

  const loading = useAppSelector((state) => state.userCompliance.loading)
  const list = useAppSelector((state) => state.userCompliance.list)

  useEffect(() => {
    if (!list || list.length === 0) {
      getUserCompliances({ includeDeleted: false })
    }
  }, [])

  return (
    <div className={styles.container}>
      <h1>User compliance</h1>
      <Card className={styles.card}>
        <UserComplianceList items={list} />
      </Card>
      <FullScreenLoadingIndicator visible={loading} />
    </div>
  )
}

export default UserCompliance

const useStyles = createUseStyles({
  container: {
    '& h1': {
      marginBottom: titleMarginBottom,
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    padding: 10,
    gap: 10
  },
})

